import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { fileInfo } from '../models/models';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  
  private maxConcurrency:number = 1;
  fileListInfo: fileInfo[] = [];
  fileCounter: number = 0;
  uploading:boolean = false;
  private fileSelected = new Subject<any>();
  private fileUploaded = new Subject<any>();
  private uploadProgress = new Subject<any>();
  fileSelected$ = this.fileSelected.asObservable();
  uploadProgress$ = this.uploadProgress.asObservable();
  fileUploaded$ = this.fileUploaded.asObservable();

  constructor(private http: HttpClient) { }

  public download(id:string) { 
    return this.http.get(`${environment.netCoreApiUrl}File/${id}/`, {
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    }); 
  }

  upload(type: number, folder: string, file: File): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();

    formData.append('file', file);
    const req = new HttpRequest('POST', `${environment.netCoreApiUrl}File/${type}/${folder}/`, formData, {
      reportProgress: true,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  uploadFile(file:any): void {
    
    if (file.blob) {
      
      file.status="INPROGRESS";
      this.upload(file.type, file.folder, file.blob).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {

            file.progress = Math.round(100 * event.loaded / event.total);
            this.onUploadProgress(file);

          } else if (event instanceof HttpResponse) {
            file.status="COMPLETED";
            this.onFileUploaded(event.body)
            this.validateQueueRun();
          }
        },
        (err: any) => {
          file.status="WITHERRORS";
        });
    }
  }

  
  onSelectFile(folder: string, file:File, fromBook: boolean) {

    const fileSize =  file.size/ (1024 ** 2);
    const obj = file;
    this.fileListInfo.push({
      blob: obj,
      fileName: file.name,
      progress:0,
      error:'',
      status:'PENDING',
      size: Math.round(fileSize * 10 ** 2) / 10 ** 2,
      type: fromBook==true?5:6,
      folder: folder
    });
    this.validateQueueRun();
    this.fileSelected.next(file);
  }

  onUploadProgress(progress:any) {
    this.uploadProgress.next(progress);
  }

  onFileUploaded(data:any) {
    this.fileUploaded.next(data);
  }

  validateQueueRun()
  {
    const currentQueue= this.fileListInfo.filter(f=>f.status=="PENDING");
    if(currentQueue!=null && currentQueue.length>0)
    {
      const isUploading = this.fileListInfo.filter(f=>f.status=="INPROGRESS").length>0;
      if(!isUploading)
      {
        this.uploading = true;  
        this.uploadFile(currentQueue[0]);
      }      
    }  
    else{
      this.uploading = false;  
    }
    
  }
}